import { Modifier } from '../modifier';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Focus extends Modifier {
  static readonly baseTitle = 'Focus';
  static readonly baseText = 'Boons with keyword Stable other than this will not fade.';
  static readonly baseIcon = 'focus';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Last;

  // Instance properties that can change
  title = Focus.baseTitle;
  text = Focus.baseText;
  icon = Focus.baseIcon;
  tags: Array<ModifierTags> = [...Focus.baseTags];
  priority = Focus.basePriority;

  public delay = false;

  update(stacks: number, params?: ModifierParams) {
    super.update(stacks, params);
    this.delay = true;
  }

  startTurn({
    dice,
    rerollMax,
    activePlayer,
    inactivePlayer,
  }: {
    dice: any[];
    rerollMax: number;
    activePlayer: any;
    inactivePlayer: any;
  }): { dice: any[]; rerollMax: number; activePlayer: any; inactivePlayer: any } {
    this.delay = false;
    return { dice, rerollMax, activePlayer, inactivePlayer };
  }

  endTurn() {
    if (!this.delay) {
      this.removeStacks(1);
    }
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Focus, Focus);
